<!--
  - Copyright (c) 2019. K+S France & Isagri Ingénierie
  - SD version du 03/06/2019 14:55:29 s
  -->

<template>
  <div id="help">
    <div class="wait" v-if="wait">
      <v-progress-linear
        :indeterminate="true"
        color="primary"
      ></v-progress-linear>
    </div>
    <div class="body" v-html="body"></div>

    <v-btn small flat block color="primary" @click="$router.go(-1)">{{
      $t("return")
    }}</v-btn>
  </div>
</template>

<script>
export default {
  name: "Help",

  data() {
    return {
      body: "",
      wait: true
    };
  },

  methods: {
    getFicheBody: id => {
      return axios.post(
        `${
          process.env.VUE_APP_URLAPI
        }Modules/easyfert/WSEasyfert.asmx/GetNodeBody`,
        {
          idNode: id
        }
      );
    }
  },

  created() {
    this.getFicheBody(this.$route.params.idNode).then(
      reponse => {
        this.wait = false;
        this.body = "";
        this.body = reponse.data.d;
      },
      message => {
        console.error("Erreur réseau ", message);
        this.wait = false;
        let alert = {
          show: true,
          dismissible: false,
          message: "Une erreur réseau est survenue, êtes-vous d'être connecté à Internet ?",
          type: "error",
          variant: null
        };

        this.$emit("on_Alert", alert);
      }
    );
  },

  beforeRouteUpdate(to, from, next) {
    console.log("RecallRoute");
    console.log(to);
    console.log(from);
    console.log(this.$route.params.idNode);
    this.getFicheBody(this.$route.params.idNode).then(
      reponse => {
        this.wait = false;
        this.body = "";
        this.body = reponse.data.d;
        console.log("Réponse : ", this.body);
        next();
      },
      message => {
        console.error(message);
      }
    );
  }
};
</script>

<style scoped></style>
